<template>
    <div class="full-height">
      <div class="row container-crud q-px-sm">
        <div class="fit">
            <q-card-section class="data-card-main grid-layout">
              <div
                v-for="(obj, index) in computedInputsTypeElements"
                :key="index"
                :class="getClassesByTheElement(obj)"
              >
                <label>{{ obj.label }}:</label>
                {{ formatedValue(model[obj.name], obj) }}
              </div>
            </q-card-section>
            <dynamic-compositions
              class="col-start-1 col-end-12"
              ref="compositions"
              :compositions-elm="formateInputsArray"
              :button-hidden="buttonHidden"
              @composition-button-click="actionButtonClickHandler"
            />
                <div id="subtitle" class="bg-gray-200 p-3 mx-1 rounded">
                    <div class="mr-36">
                        <translate>TOTAL_GENERATE</translate>: {{ total }}
                    </div>
                </div>
            </div>
      </div>
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'

const { pageDetail } = JtCrud

  @Component({
    mixins: [pageDetail],
    name: 'PageDetail',
    provide () {
      return {
        jtdynamicform: this
      }
    },
    components: { },
    props: {
      name: String,
      forms: { type: Array, required: true },
      params: Object,
      parent: Object,
      buttonHidden: {
        type: Boolean,
        default: false
      }
    }
  })
class PageDetail extends Vue {
    total = 0
    mounted () {
      this.getItensTotalValue()
    }

    getItensTotalValue () {
      const total = this.forms[0].dadosForm.items.reduce((acumulador, actualValue) => {
        return acumulador + actualValue.value
      }, 0)

      this.total = Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(total)
    }
  }
export default PageDetail
</script>
  <style lang="stylus" scoped>
  @import '~quasar-variables';

  #subtitle {
    background-color: #eceff1;
    font-weight: 500;
    height: 45px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 10%;
  }

  for num in 1 .. 12 {
    .col-start-{num} {
      grid-column-start: num;
    }
  }

  for num in 1 .. 13 {
    .col-end-{num} {
      grid-column-end: num;
    }
  }

  .grid-layout {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: max-content;
  }

  .data-card-header {
    font-size: 1.3em;
    padding: 10px 17px 0px;
  }

  .data-card-main.q-card__section {
    height: calc(100% - 65px);
    overflow: hidden;
    padding: 15px 0;
  }

  .data-card-main.q-card__section > div {
    padding: 5px 12px;
  }

  .data-card-main.q-card__section > div > label {
    font-weight: bold;
  }

  .row-grey {
    background: $ice;
  }
  </style>
